import { ChangeDetectionStrategy, Component } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.facade'
import * as AuctionActions from 'libs/gb-front/auction/data-access/src/lib/+state/auction.actions'

@Component({
  selector: 'gb-page-not-found',
  templateUrl: './gb-page-not-found.component.html',
  styleUrls: ['./gb-page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPageNotFoundComponent {
  errorMessage = 'PAGE_NOT_FOUND.HEADER'

  auction$ = this.auctionFacade.auction$

  constructor(private auctionFacade: AuctionFacade, private router: Router, private route: ActivatedRoute) {
    const state = this.router.getCurrentNavigation()?.extras.state

    if (state && state['errorMessage']) {
      this.errorMessage = state['errorMessage']
    }
  }

  goToItems(): void {
    this.router.navigate(['../items'], { relativeTo: this.route })
  }

  goToHomepage(): void {
    this.auctionFacade.dispatch(AuctionActions.redirectHomePage())
  }
}
